module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":{"current-location":"Current location"}},"es":{"label":{"current-location":"Ubicación actual"}}}')
  delete Component.options._Ctor
}
